<template>
  <b-col sm="12" class="p-0">
    <b-row>
      <b-col
        md="6"
        xl="3"
        style="margin-bottom: 2rem"
        v-for="(item, i) in summaries"
        :key="i"
        @click="$emit('onClickCard', item.status)"
      >
        <div
          class="d-flex align-items-center bg-white p-3 shadow card-certificate h-full"
        >
          <div class="card-icon mr-2" :style="`background: ${item.color} ;`">
            <FleetCircleOutline color="black" />
          </div>
          <div class="text-left">
            <h5 class="line-height mb-1"
              ><strong>{{ item.total ?? '-' }}</strong></h5
            >
            <h6 class="">
              {{ item.name }}
            </h6>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>
<script>
import CalendarOutlineIcon from './Icons/CalendarOutlineIcon.vue'
import FleetCircleOutline from './Icons/FleetCircleOutline.vue'

export default {
  name: 'PlanMaintenanceSummary',
  props: {
    meta: {
      type: Object,
    },
  },
  components: {
    FleetCircleOutline,
    CalendarOutlineIcon,
  },
  data() {
    return {
      summaries: [
        {
          name: 'Active Maintenance',
          total: this.meta?.active_maintenance || 0,
          color: '#71FFD7',
          prop: 'active_maintenance',
          status: 'ACTIVE',
        },
        {
          name: 'Toward Maintenance',
          total: this.meta?.toward_maintenance || 0,
          color: '#B9D1FF',
          prop: 'toward_maintenance',
          status: 'TOWARDS',
        },
        {
          name: 'Overdue Maintenance',
          total: this.meta?.overdue_maintenance || 0,
          color: '#FFD1D1',
          prop: 'overdue_maintenance',
          status: 'OVERDUE',
        },
        {
          name: 'Posponed Maintenance',
          total: this.meta?.postpone_maintenance || 0,
          color: '#FFD3A0',
          prop: 'postpone_maintenance',
          status: 'POSTPONE',
        },
      ],
    }
  },
  watch: {
    meta: {
      handler(newVal) {
        for (const key in newVal) {
          this.summaries.forEach((el, i) => {
            if (key == el.prop) {
              el.total = newVal[key]
            }
          })
        }
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.card-certificate {
  border-radius: 1rem;
  transition: all;
  transition-duration: 250ms;
}
.card-certificate:hover {
  scale: 1.05;
}
.card-icon {
  border-radius: 1rem;
  font-size: 2rem;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
